module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 110);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_Modal_Modal; });
__webpack_require__.d(__webpack_exports__, "Body", function() { return /* reexport */ Modal_Body; });
__webpack_require__.d(__webpack_exports__, "Header", function() { return /* reexport */ Modal_Header; });
__webpack_require__.d(__webpack_exports__, "Footer", function() { return /* reexport */ Modal_Footer; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(4);

// EXTERNAL MODULE: external "@splunk/react-ui/ModalLayer"
var ModalLayer_ = __webpack_require__(65);
var ModalLayer_default = /*#__PURE__*/__webpack_require__.n(ModalLayer_);

// EXTERNAL MODULE: external "@splunk/ui-utils/focus"
var focus_ = __webpack_require__(24);

// EXTERNAL MODULE: external "@splunk/react-ui/ScrollContainerContext"
var ScrollContainerContext_ = __webpack_require__(35);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/react-ui/Box"
var Box_ = __webpack_require__(8);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box_);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/Modal/BodyStyles.ts



var StyledBox = external_styled_components_default()(Box_default.a).withConfig({
  displayName: "BodyStyles__StyledBox",
  componentId: "lv54z7-0"
})(["background-color:", ";", " ", " flex:0 1 auto;overflow:auto;@media all and (-ms-high-contrast:none){*::-ms-backdrop,&{max-height:calc(100vh - 180px);}}"], Object(themes_["pick"])({
  enterprise: themes_["variables"].backgroundColor,
  prisma: themes_["variables"].backgroundColorDialog
}), Object(themes_["pick"])({
  enterprise: {
    comfortable: Object(external_styled_components_["css"])(["padding:28px;"]),
    compact: Object(external_styled_components_["css"])(["padding:24px;"])
  },
  prisma: {
    comfortable: Object(external_styled_components_["css"])(["padding:12px 24px;&:first-child{padding-top:36px;}&:last-child{padding-bottom:36px;}"]),
    compact: Object(external_styled_components_["css"])(["padding:8px 24px;&:first-child{padding-top:26px;}&:last-child{padding-bottom:26px;}"])
  }
}), Object(themes_["pick"])({
  prisma: Object(external_styled_components_["css"])(["color:", ";"], themes_["variables"].contentColorActive)
}));

// CONCATENATED MODULE: ./src/Modal/Body.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var propTypes = {
  children: external_prop_types_default.a.node
};

/**
 * A styled container for `Modal` body content.
 */
function Body(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["children"]);

  // @docs-props-type BodyPropsBase
  var _useState = Object(external_react_["useState"])(),
      _useState2 = _slicedToArray(_useState, 2),
      scrollContainer = _useState2[0],
      setScrollContainer = _useState2[1];

  var scrollContainerRef = Object(external_react_["useCallback"])(function (el) {
    setScrollContainer(el);
  }, []);
  return /*#__PURE__*/external_react_default.a.createElement(StyledBox, _extends({
    "data-test": "body"
  }, otherProps, {
    elementRef: scrollContainerRef
  }), /*#__PURE__*/external_react_default.a.createElement(ScrollContainerContext_["ScrollContainerProvider"], {
    value: scrollContainer
  }, children));
}

Body.propTypes = propTypes;
/* harmony default export */ var Modal_Body = (Body);
// CONCATENATED MODULE: ./src/Modal/FooterStyles.ts



var FooterStyles_StyledBox = external_styled_components_default()(Box_default.a).withConfig({
  displayName: "FooterStyles__StyledBox",
  componentId: "yszcmv-0"
})(["flex:0 0 auto;text-align:right;padding:", ";", " & > button{min-width:80px;}"], Object(themes_["pick"])({
  enterprise: themes_["variables"].spacing,
  prisma: {
    comfortable: '24px',
    compact: '18px 24px'
  }
}), Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["background-color:", ";border-top:1px solid ", ";"], themes_["variables"].backgroundColor, themes_["variables"].borderColor),
  prisma: Object(external_styled_components_["css"])(["background-color:", ";"], themes_["variables"].backgroundColorDialog)
}));

// CONCATENATED MODULE: ./src/Modal/Footer.tsx
function Footer_extends() { Footer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Footer_extends.apply(this, arguments); }

function Footer_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Footer_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Footer_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Footer_propTypes = {
  children: external_prop_types_default.a.node
};

/**
 * A styled container for `Modal` footer content.
 */
function Footer(_ref) {
  var children = _ref.children,
      otherProps = Footer_objectWithoutProperties(_ref, ["children"]);

  // @docs-props-type FooterPropsBase
  return /*#__PURE__*/external_react_default.a.createElement(FooterStyles_StyledBox, Footer_extends({
    "data-test": "footer"
  }, otherProps), children);
}

Footer.propTypes = Footer_propTypes;
/* harmony default export */ var Modal_Footer = (Footer);
// EXTERNAL MODULE: external "@splunk/react-ui/CloseButton"
var CloseButton_ = __webpack_require__(59);
var CloseButton_default = /*#__PURE__*/__webpack_require__.n(CloseButton_);

// CONCATENATED MODULE: ./src/Modal/HeaderStyles.ts



var HeaderStyles_StyledBox = external_styled_components_default()(Box_default.a).withConfig({
  displayName: "HeaderStyles__StyledBox",
  componentId: "sc-1y722ut-0"
})(["flex:0 0 auto;display:flex;", " position:relative;min-height:", ";background-color:", ";padding:", ";align-items:center;padding-right:", ";"], Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["border-bottom:1px solid ", ";"], themes_["variables"].borderColor)
}), Object(themes_["pick"])({
  enterprise: '30px',
  prisma: {
    comfortable: '60px',
    compact: '52px'
  }
}), Object(themes_["pick"])({
  enterprise: themes_["variables"].backgroundColor,
  prisma: themes_["variables"].backgroundColorDialog
}), Object(themes_["pick"])({
  enterprise: '25px 28px',
  prisma: {
    comfortable: '18px 24px',
    compact: '14px 24px'
  }
}), function (_ref) {
  var $close = _ref.$close;
  return $close && Object(themes_["pick"])({
    enterprise: '54px',
    prisma: {
      comfortable: '64px',
      compact: '56px'
    }
  });
});
var StyledTitleWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "HeaderStyles__StyledTitleWrapper",
  componentId: "sc-1y722ut-1"
})(["", ";flex-direction:column;"], themes_["mixins"].reset('flex'));
var StyledIcon = external_styled_components_default.a.svg.withConfig({
  displayName: "HeaderStyles__StyledIcon",
  componentId: "sc-1y722ut-2"
})(["margin-right:16px;", " width:", ";height:", ";padding:2px;border-radius:4px;flex-shrink:0;"], Object(themes_["pick"])({
  prisma: Object(external_styled_components_["css"])(["background-color:", ";"], themes_["variables"].transparent)
}), Object(themes_["pick"])({
  comfortable: '40px',
  compact: '32px'
}), Object(themes_["pick"])({
  comfortable: '40px',
  compact: '32px'
}));
var StyledTitle = external_styled_components_default.a.div.withConfig({
  displayName: "HeaderStyles__StyledTitle",
  componentId: "sc-1y722ut-3"
})(["", ";font-size:20px;margin:0;overflow-wrap:break-word;font-weight:", ";", ""], themes_["mixins"].reset('block'), themes_["variables"].fontWeightSemiBold, Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["line-height:22px;"]),
  prisma: Object(external_styled_components_["css"])(["color:", ";line-height:24px;"], themes_["variables"].contentColorActive)
}));
var StyledSubtitle = external_styled_components_default.a.div.withConfig({
  displayName: "HeaderStyles__StyledSubtitle",
  componentId: "sc-1y722ut-4"
})(["", ";font-size:14px;overflow-wrap:break-word;line-height:", ";"], themes_["mixins"].reset('block'), Object(themes_["pick"])({
  enterprise: themes_["variables"].lineHeight,
  prisma: '20px'
}));
var StyledButtonsWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "HeaderStyles__StyledButtonsWrapper",
  componentId: "sc-1y722ut-5"
})(["", ";position:absolute;top:", ";right:", ";bottom:50%;", " max-height:35px;transform-origin:bottom right;transform:rotate(-90deg) translateX(100%);"], themes_["mixins"].reset('block'), Object(themes_["pick"])({
  enterprise: 0,
  prisma: {
    comfortable: '-2px',
    compact: '-6px'
  }
}), Object(themes_["pick"])({
  enterprise: 0,
  prisma: {
    comfortable: '-2px',
    compact: '-6px'
  }
}), Object(themes_["pick"])({
  prisma: {
    comfortable: Object(external_styled_components_["css"])(["min-height:35px;"]),
    compact: Object(external_styled_components_["css"])(["min-height:30px;"])
  }
}));
var StyledClose = external_styled_components_default.a.div.withConfig({
  displayName: "HeaderStyles__StyledClose",
  componentId: "sc-1y722ut-6"
})(["", ";position:absolute;right:0;top:0;transform:rotate(90deg) translate(-50%,-50%);"], themes_["mixins"].reset('block'));

// CONCATENATED MODULE: ./src/Modal/Header.tsx
function Header_extends() { Header_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Header_extends.apply(this, arguments); }

function Header_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Header_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Header_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Header_propTypes = {
  children: external_prop_types_default.a.node,
  icon: external_prop_types_default.a.node,
  onRequestClose: external_prop_types_default.a.func,
  subtitle: external_prop_types_default.a.node,
  title: external_prop_types_default.a.string
};

/**
 * A styled container for `Modal` header content.
 */
function Header(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      onRequestClose = _ref.onRequestClose,
      subtitle = _ref.subtitle,
      title = _ref.title,
      otherProps = Header_objectWithoutProperties(_ref, ["children", "icon", "onRequestClose", "subtitle", "title"]);

  // @docs-props-type StepPropsBase
  return /*#__PURE__*/external_react_default.a.createElement(HeaderStyles_StyledBox, Header_extends({
    $close: !!onRequestClose,
    "data-test": "header"
  }, otherProps), icon && /*#__PURE__*/external_react_default.a.createElement(StyledIcon, null, icon), title ? /*#__PURE__*/external_react_default.a.createElement(StyledTitleWrapper, null, title && /*#__PURE__*/external_react_default.a.createElement(StyledTitle, {
    "data-test": "title"
  }, title), subtitle && /*#__PURE__*/external_react_default.a.createElement(StyledSubtitle, {
    "data-test": "subtitle"
  }, subtitle)) : children, onRequestClose && /*#__PURE__*/external_react_default.a.createElement(StyledButtonsWrapper, null, onRequestClose && /*#__PURE__*/external_react_default.a.createElement(StyledClose, null, /*#__PURE__*/external_react_default.a.createElement(CloseButton_default.a, {
    onClick: onRequestClose,
    "data-test": "close"
  }))));
}

Header.propTypes = Header_propTypes;
/* harmony default export */ var Modal_Header = (Header);
// EXTERNAL MODULE: external "react-spring"
var external_react_spring_ = __webpack_require__(18);

// CONCATENATED MODULE: ./src/Modal/ModalStyles.ts



var Styled = external_styled_components_default()(external_react_spring_["animated"].div).withConfig({
  displayName: "ModalStyles__Styled",
  componentId: "sc-5fn8ds-0"
})(["", ";flex-direction:column;position:fixed;left:50%;transform:translateX(-50%);z-index:", ";", ""], themes_["mixins"].reset('flex'), themes_["variables"].zindexModal, Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["box-shadow:0 1px 5px ", ";max-height:calc(100vh - ", " * 4);max-width:calc(100vw - ", " * 4);"], themes_["variables"].black, themes_["variables"].spacing, themes_["variables"].spacing),
  prisma: Object(external_styled_components_["css"])(["box-shadow:", ";max-height:calc(100vh - ", " * 4);max-width:calc(100vw - ", " * 4);"], themes_["variables"].modalShadow, themes_["variables"].spacingXLarge, themes_["variables"].spacingXLarge)
}));

// CONCATENATED MODULE: ./src/Modal/Modal.tsx
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function Modal_extends() { Modal_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Modal_extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || Modal_unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function Modal_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Modal_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Modal_arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return Modal_arrayLikeToArray(arr); }

function Modal_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var Modal_propTypes = {
  children: external_prop_types_default.a.node,
  onRequestClose: external_prop_types_default.a.func,
  open: external_prop_types_default.a.bool
};
var defaultProps = {
  open: false
};

var Modal_Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "el", null);

    _defineProperty(_assertThisInitialized(_this), "getDefaultMotionStyle", function () {
      return {
        top: 0
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getMotionStyle", function () {
      if (_this.props.open) {
        return {
          top: 40
        };
      }

      return {
        top: 0
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalMount", function (element) {
      _this.el = element;

      if (element) {
        Object(external_lodash_["defer"])(focus_["takeFocus"], element);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalKeyDown", function (e) {
      if (_this.el !== null) {
        Object(focus_["handleTab"])(_this.el, e.nativeEvent);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function (e) {
      var _this$props$onRequest, _this$props;

      (_this$props$onRequest = (_this$props = _this.props).onRequestClose) === null || _this$props$onRequest === void 0 ? void 0 : _this$props$onRequest.call(_this$props, e);
    });

    _defineProperty(_assertThisInitialized(_this), "renderModal", function (interpolatedStyle) {
      var _this$props2 = _this.props,
          style = _this$props2.style,
          children = _this$props2.children;
      var top = interpolatedStyle.top,
          opacity = interpolatedStyle.opacity;
      var clonedChildren = external_react_["Children"].toArray(children).filter(external_react_["isValidElement"]);
      return /*#__PURE__*/external_react_default.a.createElement(Styled // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
      , Modal_extends({
        ref: _this.handleModalMount,
        "data-test": "modal",
        style: _objectSpread(_objectSpread({}, style), {}, {
          top: top,
          opacity: opacity
        }),
        tabIndex: -1,
        onKeyDown: _this.handleModalKeyDown,
        role: "dialog"
      }, Object(external_lodash_["omit"])(_this.props, [].concat(_toConsumableArray(Object(external_lodash_["keys"])(Modal.propTypes)), ['style']))), clonedChildren);
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/external_react_default.a.createElement(ModalLayer_default.a, {
        open: this.props.open,
        getDefaultMotionStyle: this.getDefaultMotionStyle,
        renderModal: this.renderModal,
        getMotionStyle: this.getMotionStyle,
        onRequestClose: this.handleRequestClose
      });
    }
  }]);

  return Modal;
}(external_react_["Component"]);

_defineProperty(Modal_Modal, "propTypes", Modal_propTypes);

_defineProperty(Modal_Modal, "defaultProps", defaultProps);

_defineProperty(Modal_Modal, "Header", Modal_Header);

_defineProperty(Modal_Modal, "Body", Modal_Body);

_defineProperty(Modal_Modal, "Footer", Modal_Footer);

/* harmony default export */ var src_Modal_Modal = (Modal_Modal);

// CONCATENATED MODULE: ./src/Modal/index.ts



/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("react-spring");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/focus");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/ScrollContainerContext");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/CloseButton");

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/ModalLayer");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Box");

/***/ })

/******/ });